module.exports = __webpack_public_path__ + "static/img/introduction_to_online_classes.52174971.png";